import React from "react";
import PropTypes from "prop-types";

const FormErrorMessage = (props) => (
  <div className="alert alert-danger">
    <ul>
      {[...props.errorMessage].map((err) => {
        return <li key={err}>{err}</li>;
      })}
    </ul>
  </div>
);

FormErrorMessage.propTypes = {
  errorMessage: PropTypes.arrayOf(PropTypes.string),
};

export default FormErrorMessage;



// WEBPACK FOOTER //
// ./src/components/forms/FormErrorMessage.js